import { apiRequestFactory } from "@/api/util";

const apiSpec = {
  "/user/self/connections/list": {
    listResponse: "connections",
  },
};

const apiRequest = apiRequestFactory(apiSpec);

export default {
  list: (options, args) => apiRequest(options, "/user/self/connections/list", args),
};
